import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as PillStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Pill";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    align-self: center;
    width: 100%;

    /* Fix position for icon in SortFilter button */
    ${IconWrapper} {
        display: flex;
        .icon {
            position: relative;
            top: 2px;
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        display: inline-block;
        width: auto;
        max-width: 100%;
    }
`;

export const Pill = styled.div`
    @media ${getBreakpoint("down", "lg")} {
        display: none;
    }

    ${PillStyles.Wrapper} {
        color: ${theme.colors.platinumDark};
        border-color: ${theme.colors.platinumMedium};
    }
`;

export const Popup = styled.div<{ hasNavOffset?: boolean; isFixed?: boolean }>`
    position: fixed;
    top: ${({ hasNavOffset, isFixed }) =>
        `calc(${hasNavOffset ? "var(--visibleHeaderHeight, 0)" : "0px"} + ${isFixed ? 61 : 119}px)`}; /* TopOffset of sticky bar + height of sticky bar(61px) */

    right: 12px;
    min-width: 50vw;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumMedium};
    z-index: ${theme.zIndex.popover};

    @media ${getBreakpoint("up", "lg")} {
        position: absolute;
        top: 64px; /* 40 (height button) + 24 (spacing) */
        left: auto;
        right: 8px;
        min-width: 256px;
    }

    html[dir="rtl"] & {
        left: 12px;
        right: auto;
        @media ${getBreakpoint("up", "lg")} {
            left: 8px;
            right: auto;
        }
    }
`;
